import i18next from 'i18next'
import detector from "i18next-browser-languagedetector";
import { initReactI18next } from 'react-i18next'
import ChainedBackend from "i18next-chained-backend";
import HttpBackend from "i18next-http-backend";
import LocalStorageBackend from "i18next-localstorage-backend";

import en from './enUS.json'
import th from './thTH.json'

const resources = {
    "th-TH":{
        translation:th
    },
    "en-EN":{
        translation:en
    }
}

i18next.use(detector).use(ChainedBackend).use(initReactI18next).init({
    resources,
    detection: {
        order: ['localStorage', 'navigator'],
        caches: ['localStorage'],
        lookupLocalStorage: 'i18nextLng',
    },
    fallbackLng: 'en-EN',
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
        escapeValue: false,
    },
    react: {
        useSuspense: false,
    },
    backend: {
        backends: [
          LocalStorageBackend,
          HttpBackend
        ],
        backendOptions: [{
          expirationTime: 7 * 24 * 60 * 60 * 1000 // 7 days
        },]
      }
});

export default i18next;

